/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Starter_ConnectorsInputs */



/**
* | output |
* | --- |
* | "External connectors & spaces" |
*
* @param {Plan_Feature_Starter_ConnectorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_starter_connectors = /** @type {((inputs?: Plan_Feature_Starter_ConnectorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Starter_ConnectorsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Konnektoren & Spaces")
	return /** @type {LocalizedString} */ ("External connectors & spaces")
});